import dayjs from 'shared/helpers/dayjs';
import routesConfig from 'constants/routesConfig.json';
import formatDateParam from 'events/helpers/dateFormat';

export default function getCreatedNoteLocation(
  eventId: string,
  selectedDate: dayjs.Dayjs,
  today: dayjs.Dayjs = dayjs().startOf('day')
): { pathname: string; search: string } {
  const isToday = selectedDate.isSame(today, 'day');
  return {
    pathname: `${routesConfig.EVENT_PAGE}/${eventId}`,
    search: isToday ? '' : `?date=${formatDateParam(selectedDate)}`,
  };
}
